import { __awaiter, __generator, __read } from "tslib";
import { TrustFrameError } from '../../errors';
import { createAppleTokenBindingApi2 } from '../../api/create-apple-token-binding-v2';
import { paymentForm } from '../payment-form';
import { ApplePayProvider } from './ApplePayProvider';
import { loadApplePaySdk } from './loadApplePaySdk';
export var bindAppleTokenV2 = function (apiHost, options) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, url, targetOrigin, request, provider, onDomMount, onDomUnmount;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4, Promise.all([
                    createAppleTokenBindingApi2(apiHost, options),
                    loadApplePaySdk()
                ])];
            case 1:
                _a = __read.apply(void 0, [_b.sent(), 1]), url = _a[0];
                targetOrigin = new URL(url).origin;
                request = {
                    merchantCapabilities: ['supports3DS'],
                    supportedNetworks: [],
                    countryCode: options.countryCode,
                    currencyCode: options.currency,
                    total: { label: options.businessName, amount: options.amount },
                    recurringPaymentRequest: options.recurringPaymentRequest
                };
                provider = null;
                onDomMount = function (frame) {
                    if (!frame.contentWindow) {
                        throw new TrustFrameError('Unable to attach ApplePayProvider to form frame');
                    }
                    provider = new ApplePayProvider(frame.contentWindow, targetOrigin, request);
                    provider.start();
                };
                onDomUnmount = function () {
                    if (provider) {
                        provider.stop();
                        provider = null;
                    }
                };
                return [2, paymentForm(apiHost, { url: url, onDomMount: onDomMount, onDomUnmount: onDomUnmount })];
        }
    });
}); };
